import { axiosClientRegistry, type AxiosClients } from './axiosClientRegistry'

export interface Options {
  clients: AxiosClients
}

export const registerAxiosClients = (options: Options) => {
  const { clients } = options

  axiosClientRegistry.setClients(clients)
}
